module.exports = __webpack_public_path__ + "img/ssyx_33.500df6bc.jpg";